import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import checkIcon from '../../assets/Icons/check-mark.png';
import serverIcon from '../../assets/Icons/server.png';
import vaultIcon from '../../assets/Icons/vault.png';
import { selectMFilesConfig } from '../../redux/mfilesConfig/mfilesConfig.selector';
import {
  selectActiveSheetName,
  selectFileTitle,
} from '../../redux/sheetConfig/sheetConfig.selector';
import '../../styles/NavHeader.scss';

interface NavHeaderProps {
  activeObject?: string;
}

const NavHeader: FC<NavHeaderProps> = () => {
  const { host, vaultName, isMFilesConnected } =
    useSelector(selectMFilesConfig);
  const activeSheetName = useSelector(selectActiveSheetName);
  const fileTitle = useSelector(selectFileTitle);
  const currentTitle = fileTitle?.find((x) => x.sheetName === activeSheetName);

  return (
    <div className="nav-file-name nav-header">
      {host && vaultName && isMFilesConnected && (
        <>
          <div className="nav-item">
            <img src={serverIcon} alt="server" />
            <span title={host}>Server: {host.split('/').pop()}</span>
          </div>

          <div className="nav-item">
            <img src={vaultIcon} alt="vault" />
            <span>Vault: {vaultName}</span>
          </div>
        </>
      )}
      {currentTitle?.fileTitle && currentTitle?.fileTitle !== 'null' && (
        <div className="nav-item">
          <img src={checkIcon} alt="active object" />
          <span>
            {!currentTitle.fileTitle.includes('.')
              ? currentTitle.fileTitle.includes('View ID')
                ? 'View'
                : 'Class'
              : 'File Name'}
            : {currentTitle.fileTitle}
          </span>
        </div>
      )}
    </div>
  );
};

export default memo(NavHeader);
